export default {
  TaxPaymentSubstitute: 'Người nộp thay',
  Address: 'Địa chỉ',
  District: 'Huyện',
  ConsciousAndCity: 'Tỉnh, TP',
  ConsciousAndCityTitle: 'Tỉnh, Thành phố',
  BankRequest: 'Đề nghị NH (KBNN)',
  BankRequestTitle: 'Đề nghị ngân hàng (kho bạc nhà nước)',
  CitingAccount: 'Trích TK số',
  CitingAccountTitle: 'Trích tài khoản số',
  OrReceiptCash: 'Hoặc thu tiền mặt để',
  SubmitStateBudget: 'Nộp vào NSNN',
  SubmitStateBudgetTitle: 'Nộp vào ngân sách nhà nước',
  AccountTempReceipt: 'TK tạm thu',
  AccountTempReceiptTitle: 'Tài khoản tạm thu',
  AccountRefund: 'TK thu hồi quỹ hoàn thuế GTGT',
  AccountRefundTitle: 'Tài khoản thu hồi quỹ hoàn thuế giá trị gia tăng',
  StateBudget: 'Tại KBNN',
  StateBudgetTitle: 'Tại kho bạc nhà nước',
  OpenFrom: 'Mở tại NHTM UN thu',
  OpenFromTitle: 'Mở tại ngân hàng thương mại ủy nhiệm thu',
  Conclude: 'Trường hợp nộp theo kết luận của CQ có thẩm quyền',
  ConcludeTitle: 'Trường hợp nộp theo kết luận của cơ quan có thẩm quyền',
  StateAudit: 'Kiểm toán nhà nước',
  InspectTC: 'Thanh tra TC',
  InspectTCTitle: 'Thanh tra tài chính',
  InspectCP: 'Thanh tra CP',
  InspectCPTitle: 'Thanh tra chính phủ',
  OtherAgencies: 'CQ có thẩm quyền khác',
  OtherAgenciesTitle: 'Cơ quan có thẩm quyền khác',
  ReceiptAgencyName: 'Tên CQ quản lý thu',
  ReceiptAgencyNameTitle: 'Tên cơ quan quản lý thu',
  Declaration: 'Tờ khai HQ, QĐ số',
  DeclarationTitle: 'Tờ khai hải quan, quyết định số',
  Date: 'Ngày'
};
